<script setup lang="ts" generic="T extends BaseProps<any>">
import { PV } from "@/widgets";
import type { BaseProps } from "../props";

const props = defineProps<{
    param: T;
    collapsed?: boolean;
    toggleable?: boolean;
}>();
</script>

<template>
    <PV.Panel v-if="props.param.embedMode === undefined" :collapsed="props.collapsed" :toggleable="props.toggleable">
        <template #header>
            <slot name="header"></slot>
        </template>

        <template #icons>
            <slot name="icons"></slot>
        </template>

        <slot></slot>
    </PV.Panel>
    <div v-else>
        <slot></slot>
    </div>
</template>
